<template>
  <div class="white" id="Dashboard">




        <v-card flat class="mt-0 pt-0 white">
          <keep-alive exclude="SavedSchoolInfo">
          
              <router-view :key="$route.fullPath" ></router-view>
           
          </keep-alive>
        </v-card>




      <!-- CASPA Cycle Card -->
      <!-- <v-container class="pb-0">
        <v-card tile  class="caspaCard mt-4 ">
              <v-container class="pa-2 ">
                  <v-layout row align-center  >
                      <v-layout column  >
                            <v-layout row align-baseline  class="mb-0">
                                <span class="light-blue--text text--darken-4 font-weight-bold title">CASPA</span>
                                <span class="caption ml-1 mb-0 gray--text">2018 - 2019</span>
                            </v-layout>


                            <v-layout row align-baseline  >
                                <span class="body-1  grey--text">Cycle closes  </span>
                                <span class="red--text caption ml-1">{{ '03-19-2019' | moment("from")}}</span>
                            </v-layout>


                      </v-layout>

                          <v-layout column align-center justify-center style="width:5%" class="ml-5 pl-5">
                              <v-icon color="green" >check_circle</v-icon>
                              <span class="ml-1 green--text caption ">Open</span>
                          </v-layout>
                  </v-layout>

              </v-container>
        </v-card>
      </v-container> -->








  </div>
</template>
<script>
import * as firebase from 'firebase'
export default {
  data() {
    return {
      alert: true,
      value: 100,
            cards: [
        { title: 'Pre-fab homes', src: 'https://cdn.vuetifyjs.com/images/cards/house.jpg', flex: 12 },
        { title: 'Favorite road trips', src: 'https://cdn.vuetifyjs.com/images/cards/road.jpg', flex: 6 },
        { title: 'Best airlines', src: 'https://cdn.vuetifyjs.com/images/cards/plane.jpg', flex: 6 }
      ]

    };
  },
  methods: {
    close() {
      this.$router.go("-1");
    },
    showLoginSignUpScreen () {
      this.$router.push('/LoginSignupPage')
    },
    showAccountScreen () {
      this.$router.push('/myaccount')
    },
    logout() {
      firebase.auth().signOut().then(function() {
      });
      var user = null
      this.$store.dispatch("logout", user );
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    savedSchools() {
      return this.$store.getters.savedSchools;
    },
    userEvaluations() {
      return this.$store.getters.userEvaluations;
    },
    paShadowingHours() {
      return this.$store.getters.paShadowingHours;
    },
    totalPaShadowingHours() {
      return this.$store.getters.totalPaShadowingHours;
    },
    directPaidPatientHours() {
      return this.$store.getters.directPaidPatientInfo;
    },
    totalDirectPaidPatientHours() {
      return this.$store.getters.totalDirectPaidHours
    },
    directPatientHours() {
      return this.$store.getters.directPatientInfo;
    },
    totalDirectHours() {
      return this.$store.getters.totalDirectHours;
    },
    indirectPatientHours() {
      return this.$store.getters.indirectPatientInfo;
    },
    totalIndirectHours() {
      return this.$store.getters.totalIndirectHours;
    },
    volunteerPatientHours() {
      return this.$store.getters.volunteerHoursInfo;
    },
    totalVolunteerHours() {
      return this.$store.getters.totalVolunteerHours;
    },
    totalHealthcareExperienceHours() {
      return this.$store.getters.totalHealthcareExperienceHours
    },
    userExams() {
      return this.$store.getters.userExams
    },
    overallCaspaGpa() {
      return this.$store.getters.overallCaspaGpa
    },
    scienceCaspaGpa() {
      return this.$store.getters.scienceCaspaGpa
    },
    nonscienceCaspaGpa() {
      return this.$store.getters.nonscienceCaspaGpa
    },
    userColleges() {
        return this.$store.getters.userColleges
    },
  }
};
</script>

<style scoped>

.card {
  border-radius: 5px;
}
.caspaCard {
    border-radius: 5px;
}
.menu {
  z-index: 100;
  position: fixed;
  bottom: 0;
}
::-webkit-scrollbar {
    display: none;
}
.tabContent {
  margin-top: 5px;

}

.alert {
  z-index: 3;
}
a {
  text-decoration: none;
}
.schoolName {
  font-size: 20px;
}

.toolbarContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

img {
  width: 70px;
  height: 70px;
}

.iconRow {
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

#tabs {
  top: 150px;
  position: fixed;
}

h2 {
  color: rgb(87, 87, 87);
  margin-left: 10px;
}

.signupOrLoginContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
}

.subtitle {
  color: rgb(85, 85, 85);
}

.text {
  font-size: 20px;
  color: rgb(85, 85, 85);
  margin-top: 20px;
}

.background {
  background-color: rgb(255, 255, 255);
}

   #buttonShadow {
    position: sticky;
    box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue